<section class="px-xs !py-lg h-full bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Liste des formations obligatoires réglementaires</h3>
    <div hlmCardAction>
      <button (click)="ajouterFormation()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Ajouter une formation
      </button>
    </div>
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh></th>
            <th hlmTh>Nom de la formation</th>
            <th hlmTh>Durée de validité</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (formation of formations() | trierPar: 'nom'; track formation.id) {
            <tr hlmTr>
              <td hlmTd>
                <button (click)="formation.expanded = !formation.expanded" variant="ghost" size="icon" hlmBtn>
                  <ng-icon class="collapse-icon" [class.rotated]="formation.expanded" name="lucideChevronDown" />
                </button>
              </td>
              <td class="flex items-center" hlmTd>
                <span>{{ formation.nom }}</span>
                <hlm-popover>
                  <button variant="ghost" size="icon" hlmPopoverTrigger hlmBtn>
                    <ng-icon name="lucideInfo" />
                  </button>
                  <div class="grid w-80 gap-4" *brnPopoverContent="let ctx" hlmPopoverContent>
                    <div hlmItemGroup>
                      @if (formation.description) {
                        <div hlmItem>
                          <div class="gap-1" hlmItemContent>
                            <div hlmItemTitle>Description</div>
                            <p hlmItemDescription>{{ formation.description }}</p>
                          </div>
                        </div>
                        <div hlmItemSeparator></div>
                      }
                      @if (formation.public) {
                        <div hlmItem>
                          <div class="gap-1" hlmItemContent>
                            <div hlmItemTitle>Public concerné</div>
                            <p hlmItemDescription>{{ formation.public }}</p>
                          </div>
                        </div>
                        <div hlmItemSeparator></div>
                      }
                      @if (formation.prerequis) {
                        <div hlmItem>
                          <div class="gap-1" hlmItemContent>
                            <div hlmItemTitle>Prérequis</div>
                            <p hlmItemDescription>{{ formation.prerequis }}</p>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </hlm-popover>
              </td>
              <td hlmTd>
                @if (formation.validite) {
                  {{ formation.validite | i18nPlural: anneeMapping }}
                }
              </td>
              <td hlmTd>
                <button
                  [hlmDropdownMenuTrigger]="menu"
                  [hlmDropdownMenuTriggerData]="{ $implicit: formation }"
                  (click)="$event.stopPropagation()"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                >
                  <ng-icon name="lucideEllipsisVertical" />
                </button>
              </td>
            </tr>
            @if (formation.expanded) {
              @for (niveau of formation.niveaux; track niveau.id) {
                <tr class="bg-background-underground border-stroke-neutral-light h-xxl border-b">
                  <td hlmTd></td>
                  <td hlmTd>{{ niveau.nom }}</td>
                  <td hlmTd>{{ niveau.duree }}h</td>
                  <td hlmTd></td>
                </tr>
              }
            }
          } @empty {
            <tr hlmTr>
              <td hlmTd colspan="4">Aucune formation obligatoire réglementaire ne correspond à votre recherche</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <app-paginateur [store]="store" />
  </div>

  <ng-template #menu let-ctx>
    <hlm-dropdown-menu>
      <hlm-dropdown-menu-group>
        <button (triggered)="modifierFormation(ctx)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucidePen" size="sm" />
          Modifier la formation
        </button>
        <button (triggered)="supprimerFormation(ctx)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucideTrash" size="sm" />
          Supprimer la formation
        </button>
      </hlm-dropdown-menu-group>
    </hlm-dropdown-menu>
  </ng-template>
</section>
